import { useVariable } from '@softwareimaging/backstage';
import { Variables } from '../../backstage/config';
import { useSidecarFile } from './sidecar';
import { Introduction } from './sidecar.types';

export const useIntroduction = () => {
  const sharedResourceFolderId = useVariable<Variables>('sharedResourceFolderId');
  if (!sharedResourceFolderId) throw new Error('No shared resource folder id');

  const file = useSidecarFile<Introduction>(`${sharedResourceFolderId}:/Introduction.sidecar`);

  if (!file || !file[0]) {
    throw Error("Could got get introduction details");
  }

  return file[0];
};
